import { useEffect, useState } from 'react';
import { useLiveLink } from '../lib/messages';

/**
 * "Reconnecting…": while Stitch's live connection is down for more than a few seconds (a dropped
 * network, a server restarting), so nobody wonders why nothing moves. Once it's back, what changed
 * meanwhile arrives by itself.
 */
export function LiveLinkNote() {
  const link = useLiveLink();
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (link === 'connected') {
      setShow(false);
      return;
    }
    const t = window.setTimeout(() => setShow(true), 4000);
    return () => window.clearTimeout(t);
  }, [link]);
  if (!show) return null;
  return (
    <div className="live-link-note" role="status">
      <span className="live-link-dot" aria-hidden="true" />
      Reconnecting… Anything that changes meanwhile shows once Stitch is back.
    </div>
  );
}
